/* eslint-disable camelcase */
import React from "react";

import Number from "@cayuse/shared-react.components.form.inputs.number";

import { useTenantFormatter } from "components/BudgetBuilder/shared/TenantFormatter";
import { BUDGET_ROWS } from "globals/constants";
import { useBudgetBuilder } from "hooks/useBudgetBuilder";

// TODO: move this to a place it can be easily shared
const toCurrency = (value) => {
  return value.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
  });
};

const renderBudgetRows = (data, edit, styles) => {
  const defaultBudget = () =>
    Array.from(Object.keys(BUDGET_ROWS), (key) => ({ [key]: "0" }));

  const rows = [];

  data = {
    ...defaultBudget(),
    ...data,
  };

  for (const key in data) {
    const amount = data[key];
    // render row
    if (BUDGET_ROWS[key]?.type === "expense") {
      rows.push(
        renderBudgetRow(
          BUDGET_ROWS[key].value,
          amount,
          styles.budgetRow,
          edit,
          key,
          styles
        )
      );
    } else if (BUDGET_ROWS[key]?.type === "subTotal") {
      rows.push(
        renderBudgetRow(
          BUDGET_ROWS[key].value,
          amount,
          styles.subTotalBudgetRow,
          edit,
          key,
          styles
        )
      );
    } else if (BUDGET_ROWS[key]?.type === "total") {
      rows.push(
        renderBudgetRow(
          BUDGET_ROWS[key].value,
          amount,
          styles.totalBudgetRow,
          edit,
          key,
          styles
        )
      );
    }
  }

  return rows;
};

const renderBudgetRow = (rowName, amount, style, edit, key, styles) => {
  return (
    <tr className={style} key={key}>
      <td>{rowName}</td>
      <td>
        {edit && <Number min="0.01" step="0.01" type="number" value={amount} />}
        {!edit && <strong>{toCurrency(amount)}</strong>}
      </td>
    </tr>
  );
};

export const BudgetBuilderSummary = ({ edit, styles }) => {
  const budgetBuilderContent = useBudgetBuilder();
  const {
    totalDirectCosts,
    faCostSubtotal,
    proposedCostSubtotal,
    internalCostShare,
    externalCostShare,
    costShareSubtotal,
    total,
  } = budgetBuilderContent;

  const parsedData = {
    total_direct_costs: totalDirectCosts,
    "F&A": faCostSubtotal,
    total_sponsor_costs: proposedCostSubtotal,
    internal_share: internalCostShare,
    external_share: externalCostShare,
    total_cost_share: costShareSubtotal,
    total_project_cost: total,
  };

  return <>{renderBudgetRows(parsedData, edit, styles)}</>;
};

export default BudgetBuilderSummary;
